module.exports = __webpack_public_path__ + "static/media/mymeds_preview.587cbddb.png";